export default "__VITE_ASSET__5935da6a__"